<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
  </div>

  <!-- Header -->
  <div class="auth-header">
    <h1>{{ 'auth.resetPassword.title' | translate }}</h1>
    <p>{{ 'auth.resetPassword.subtitle' | translate }}</p>
  </div>

  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
    <!-- Password Field -->
    <div class="form-group">
      <label for="password" class="form-label">{{ 'auth.resetPassword.newPassword' | translate }}</label>
      <div class="password-toggle">
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="resetForm.get('password')?.hasError('passwordStrength') && resetForm.get('password')?.touched"
          [placeholder]="'auth.register.createPassword' | translate"
          required
        />
        <i
          [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('password')"
        ></i>
      </div>
      <span *ngIf="resetForm.get('password')?.hasError('passwordStrength') && resetForm.get('password')?.touched" class="invalid-feedback">
        {{ 'auth.common.passwordStrengthError' | translate }}
      </span>
    </div>

    <!-- Confirm Password Field -->
    <div class="form-group">
      <label for="confirmPassword" class="form-label">{{ 'auth.common.confirmPassword' | translate }}</label>
      <div class="password-toggle">
        <input
          [type]="confirmPasswordVisible ? 'text' : 'password'"
          id="confirmPassword"
          formControlName="confirmPassword"
          class="form-control"
          [class.is-invalid]="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched"
          [placeholder]="'auth.common.confirmPasswordPlaceholder' | translate"
          required
        />
        <i
          [class]="confirmPasswordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('confirmPassword')"
        ></i>
      </div>
      <span *ngIf="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched" class="invalid-feedback">
        {{ 'auth.common.passwordMismatch' | translate }}
      </span>
    </div>

    <!-- Password Requirements -->
    <div class="password-requirements">
      <div class="password-requirements-title">{{ 'auth.common.passwordRequirements.title' | translate }}</div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>{{ 'auth.common.passwordRequirements.minLength' | translate }}</span>
      </div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>{{ 'auth.common.passwordRequirements.number' | translate }}</span>
      </div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>{{ 'auth.common.passwordRequirements.special' | translate }}</span>
      </div>
    </div>

    <!-- Reset Button -->
    <div class="form-group mt-4">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="resetForm.invalid || isSubmitting"
      >
        <span *ngIf="!isSubmitting">{{ 'auth.resetPassword.resetPassword' | translate }}</span>
        <span *ngIf="isSubmitting">
          <i class="fa fa-spinner spinner me-2"></i>
          {{ 'auth.resetPassword.resetting' | translate }}
        </span>
      </button>
    </div>
  </form>

  <!-- Divider -->
  <div class="auth-divider">
    <span>{{ 'auth.common.or' | translate }}</span>
  </div>

  <!-- Back to Login -->
  <button
    type="button"
    class="btn btn-outline"
    routerLink="/auth/login"
  >
    <i class="fa fa-arrow-left me-2"></i>
    {{ 'auth.common.backToLogin' | translate }}
  </button>
</div>
